import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthFacade } from '@cigna/chcp/auth/data-access';
import { ManageUserAccessFacade } from '../+state/manage-user-access.facade';

@Component({
  selector: 'cigna-page-review-lob-pref',
  templateUrl: './page-review-lob-pref.component.html',
  styleUrls: ['./page-review-lob-pref.component.scss'],
})
export class PageReviewLobPrefComponent {
  constructor(
    private manageAccessFacade: ManageUserAccessFacade,
    public dialog: MatDialog,
    private authFacade: AuthFacade,
    private router: Router,
  ) {}

  impersonator$ = this.authFacade.isImpersonator$;
  steps$ = this.manageAccessFacade.steps$;
  selectedUserType$ = this.manageAccessFacade.selectedUserType$;
  selectedUsers$ = this.manageAccessFacade.selectedUsers$;
  hiddenSteps$ = this.manageAccessFacade.hiddenSteps$;
  submitting$ = this.manageAccessFacade.isSubmitting$;

  nextScreen(): void {
    this.router.navigateByUrl('/my-practice/manage-access/success');
  }
}
